import React, { useState, useEffect } from 'react';
import Hero from './components/Hero.jsx';
import About from './components/About.jsx';

// Enable smooth scrolling
if (typeof window !== 'undefined') {
  document.documentElement.style.scrollBehavior = 'smooth';
}
import Education from './components/Education.jsx';
import Experience from './components/Experience.jsx';
import Projects from './components/Projects.jsx';
import Skills from './components/Skills.jsx';
import Contact from './components/Contact.jsx';
import Navigation from './components/Navigation.jsx';
import Loader from './components/Loader.jsx';
import SplashCursor from './components/SplashCursor.jsx';
import './styles/App.css';

function App() {
  const [activeSection, setActiveSection] = useState('home');

  const [loading, setLoading] = useState(true);

  const menuItems = [
    { label: 'Home', ariaLabel: 'Go to home page', link: '#home' },
    { label: 'About', ariaLabel: 'Go to about section', link: '#about' },
    { label: 'Education', ariaLabel: 'Go to education section', link: '#education' },
    { label: 'Experience', ariaLabel: 'Go to experience section', link: '#experience' },
    { label: 'Projects', ariaLabel: 'Go to projects section', link: '#projects' },
    { label: 'Skills', ariaLabel: 'Go to skills section', link: '#skills' },
    { label: 'Contact', ariaLabel: 'Go to contact section', link: '#contact' }
  ];

  useEffect(() => {
    // Hide loader after 5 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'about', 'education', 'experience', 'projects', 'skills', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (loading) {
    return (
      <>
        <SplashCursor />
        <Loader />
      </>
    );
  }

  return (
    <>
    <div className="app">

      
      <Navigation activeSection={activeSection} />
      
      <main>
        <section id="home">
          <Hero />
        </section>
        
        <section id="about">
          <About />
        </section>
        
        <section id="education">
          <Education />
        </section>
        
        <section id="experience">
          <Experience />
        </section>
        
        <section id="projects">
          <Projects />
        </section>
        
        <section id="skills">
          <Skills />
        </section>
        
        <section id="contact">
          <Contact />
        </section>
      </main>
      
      <footer className="footer">
        <p>© 2026 Prajeeth.V. Made with passion & code.</p>
      </footer>
    </div>
    </>
  );
}

export default App;
